module.exports = __webpack_public_path__ + "img/k8.7b970b25.jpg";